export const GET_RTT_DASH_LOG = 'getRttDashLog';
export const GET_RTT_ERRORS_LAST_CALLS = 'getRttErrorsLastCalls';
export const GET_RTT_REFERENCES = 'getRingTreeTargetReferences';